module.exports = __webpack_public_path__ + "media/images/pic/hero/waves-ab3391f20e56922b6160fa851664929c.webp";